export const LANGS = [
  { code: "en", label: "English" },
  { code: "it", label: "Italiano" },
  { code: "fr", label: "Français" },
  { code: "ar", label: "العربية" },
];

const it = {
  common: {
    login: "Accedi", register: "Registra azienda", logout: "Esci",
    orDivider: "oppure", continueWithGoogle: "Continua con Google",
    loading: "Caricamento…", email: "Email", password: "Password",
    activityLabel: "Attività (classificazione saudita)", activitySelect: "Seleziona un'attività", activityNone: "Senza attività",
    durationYears: "Durata (anni)", countersign: "Controfirma Qafila", countersigning: "Controfirma…",
    countersignedBadge: "Controfirmato", countersignedOn: "Controfirmato il {date}", countersignToast: "Contratto controfirmato",
    notifications: "Notifiche", noNotifications: "Nessuna nuova richiesta", markAllRead: "Segna tutte come lette",
    newRequestsCount: "{n} nuove richieste", byActivity: "Portfolio per attività",
    subActivityLabel: "Sotto-attività (divisione)", subActivitySelect: "Seleziona una sotto-attività",
    filterActivity: "Filtra per attività", allActivities: "Tutte le attività",
    exportExcel: "Esporta (Excel)", statistics: "Statistiche", statsCompanies: "Aziende", statsRequests: "Richieste",
  },
  landing: {
    middleEast: "MIDDLE EAST BUSINESS PARTNER", login: "Accedi", register: "Registra azienda",
    heroOverline: "Business Exploration · GCC",
    heroTitle1: "Il tuo ponte verso il", heroTitleEm: "Middle East",
    heroSubtitle: "Qafila gestisce le richieste delle aziende da e verso il Middle East: profilo aziendale, ricerca di partner e clienti.",
    startNow: "Inizia ora", haveAccount: "Ho già un account",
    annualContract: "Contratto annuale", successFeeResult: "Success fee a risultato",
    badgeText: "Success fee sui contatti generati, solo a risultato.",
    howItWorks: "Come funziona", howTitle: "Dall'azienda al mercato in quattro passi",
    stepLabel: "Passo",
    steps: [
      { title: "Registra la tua azienda", text: "Inserisci i dati aziendali completi: sede, sito, referente e contatti." },
      { title: "Company Profile", text: "Genera automaticamente un profilo professionale pronto per il mercato GCC." },
      { title: "Invia le richieste", text: "Ricerca mirata per un incarico specifico o partnership generale con tempistiche." },
      { title: "Contratto di esplorazione", text: "Contratto di esplorazione ed introduzione con success fee." },
    ],
    ctaOverline: "Qafila", ctaTitle: "Un solo partner per esplorare i mercati del Golfo.",
    ctaText: "Attiviamo la nostra rete per generare contatti e opportunità qualificate. Tu paghi solo al risultato, con una commissione trasparente definita nel contratto di esplorazione.",
    ctaButton: "Registra la tua azienda gratis",
    footer: "Qafila — Middle East Business Exploration",
  },
  login: {
    welcome: "Bentornato", title: "Accedi al tuo account",
    submit: "Accedi", submitting: "Accesso…",
    noAccount: "Non hai un account?", registerLink: "Registra la tua azienda",
    heroText: "Esplora nuovi mercati con un partner di fiducia.",
    success: "Accesso effettuato", emailPh: "nome@azienda.com",
  },
  register: {
    overline: "Registrazione azienda", title: "Crea il tuo account",
    subtitle: "Inserisci i dati aziendali per iniziare a esplorare il Middle East.",
    account: "Account", name: "Nome e cognome",
    company: "Dati aziendali", legalName: "Ragione sociale", industry: "Settore",
    address: "Indirizzo", website: "Sito internet",
    referent: "Referente", refName: "Nome referente", role: "Ruolo", phone: "Telefono",
    submit: "Registra azienda", submitting: "Registrazione…",
    haveAccount: "Hai già un account?", loginLink: "Accedi",
    heroText: "Company profile con AI, richieste mirate e contratto di esplorazione annuale.",
    success: "Azienda registrata con successo",
    ph: { name: "Mario Rossi", email: "nome@azienda.com", password: "min. 6 caratteri", legalName: "Azienda S.r.l.", industry: "es. Manifattura, Food, Tech", address: "Via, città, paese", website: "https://…", refName: "Nome", role: "es. CEO", phone: "+39…" },
  },
  nav: { overview: "Panoramica", profile: "Company Profile", requests: "Richieste", contracts: "Contratti", logout: "Esci" },
  overview: {
    welcome: "Benvenuto, {name}", title: "La tua area Qafila",
    subtitle: "Gestisci profilo, richieste e contratto di esplorazione verso il Middle East.",
    statProfile: "Company Profile", complete: "Completo", toGenerate: "Da generare",
    statRequests: "Richieste inviate", statContracts: "Contratti",
    aiTitle: "Genera il tuo Company Profile con l'AI",
    aiText: "Trasforma i dati aziendali in un profilo professionale pronto per i mercati del Golfo.",
    aiCta: "Vai al Company Profile",
  },
  profile: {
    overline: "Azienda", title: "Company Profile",
    subtitle: "Aggiorna i dati e genera la descrizione professionale con l'AI.",
    legalName: "Ragione sociale", industry: "Settore", address: "Indirizzo", website: "Sito internet",
    refName: "Referente", role: "Ruolo", phone: "Telefono",
    notesLabel: "Note per l'AI (opzionale)", notesPh: "Prodotti/servizi principali, mercati target, punti di forza…",
    descTitle: "Descrizione profilo", descSub: "Generata dall'AI in base ai dati aziendali.",
    generateAI: "Genera con AI", generating: "Generazione…",
    descPh: "La descrizione generata comparirà qui. Puoi anche modificarla manualmente.",
    save: "Salva profilo", saving: "Salvataggio…",
    downloadPdf: "Scarica PDF", sendEmail: "Invia via email", sending: "Invio…",
    saved: "Profilo salvato", generated: "Descrizione generata con l'AI", sentTo: "Profilo inviato a {email}",
  },
  requests: {
    overline: "Ricerca", title: "Le tue richieste",
    subtitle: "Richiedi una ricerca per un incarico specifico o una partnership.",
    newRequest: "Nuova richiesta", dialogTitle: "Nuova richiesta",
    typeLabel: "Tipo di richiesta", typeSpecific: "Incarico specifico", typePartnership: "Partnership",
    titleLabel: "Titolo", descLabel: "Descrizione dettagliata", descPh: "Descrivi l'obiettivo della ricerca…",
    timelineLabel: "Tempistiche", timelinePh: "es. entro 3 mesi, Q3 2026…",
    submit: "Invia richiesta", submitting: "Invio…",
    empty: "Nessuna richiesta ancora. Creane una per iniziare la ricerca.",
    typeSpecificFull: "Incarico specifico", typePartnershipFull: "Partnership generale",
    adminNote: "Nota da Qafila", timelinePrefix: "Tempistiche:", sent: "Richiesta inviata",
    steps: ["Ricevuta", "In lavorazione", "Completata", "Chiusa"],
    status: { nuova: "nuova", in_lavorazione: "in lavorazione", completata: "completata", chiusa: "chiusa" },
  },
  contracts: {
    overline: "Accordi", title: "Contratti di esplorazione",
    subtitle: "Contratto annuale con Qafila · success fee 5% sui contatti generati.",
    generate: "Genera contratto", dialogTitle: "Genera contratto di esplorazione",
    dialogText: "Collega il contratto a una richiesta specifica: l'obiettivo esplorato apparirà chiaramente nel PDF.",
    objectiveLabel: "Obiettivo del contratto", generalOption: "Ricerca generale (Middle East)",
    optJob: "Incarico", optPartnership: "Partnership",
    confirm: "Genera contratto", generating: "Generazione…",
    empty: "Nessun contratto. Generane uno per formalizzare la ricerca con Qafila.",
    linkedRequest: "Richiesta collegata:", company: "Azienda", successFee: "Success fee",
    start: "Inizio", end: "Scadenza",
    downloadPdf: "Scarica PDF", sendEmail: "Invia via email", sending: "Invio…",
    generated: "Contratto di esplorazione generato", sentTo: "Contratto inviato a {email}",
    sign: "Firma contratto", signing: "Firma in corso…", signedBadge: "Firmato",
    signedOn: "Firmato il {date}", signedToast: "Contratto firmato con successo",
  },
  admin: {
    badge: "Admin", panelOverline: "Pannello di controllo", title: "Dashboard amministratore",
    logout: "Esci",
    cardCompanies: "Aziende", cardProfiles: "Company Profile", cardRequests: "Richieste", cardContracts: "Contratti",
    tabRequests: "Richieste", tabCompanies: "Aziende", tabContracts: "Contratti",
    noRequests: "Nessuna richiesta.", noCompanies: "Nessuna azienda.", noContracts: "Nessun contratto.",
    notesLabel: "Note interne Qafila (visibili all'azienda)", notesPh: "Aggiungi feedback o aggiornamenti per l'azienda…",
    saveNote: "Salva nota", saving: "Salvataggio…",
    sector: "Settore", site: "Sito", referent: "Referente", tel: "Tel", fee: "Fee",
    timelinePrefix: "Tempistiche:", statusUpdated: "Stato aggiornato", noteSaved: "Nota salvata",
    typeSpecific: "Incarico specifico", typePartnership: "Partnership",
  },
};

const en = {
  common: {
    login: "Sign in", register: "Register company", logout: "Sign out",
    orDivider: "or", continueWithGoogle: "Continue with Google",
    loading: "Loading…", email: "Email", password: "Password",
    activityLabel: "Activity (Saudi classification)", activitySelect: "Select an activity", activityNone: "No activity",
    durationYears: "Duration (years)", countersign: "Qafila countersign", countersigning: "Countersigning…",
    countersignedBadge: "Countersigned", countersignedOn: "Countersigned on {date}", countersignToast: "Contract countersigned",
    notifications: "Notifications", noNotifications: "No new requests", markAllRead: "Mark all as read",
    newRequestsCount: "{n} new requests", byActivity: "Portfolio by activity",
    subActivityLabel: "Sub-activity (division)", subActivitySelect: "Select a sub-activity",
    filterActivity: "Filter by activity", allActivities: "All activities",
    exportExcel: "Export (Excel)", statistics: "Statistics", statsCompanies: "Companies", statsRequests: "Requests",
  },
  landing: {
    middleEast: "MIDDLE EAST BUSINESS PARTNER", login: "Sign in", register: "Register company",
    heroOverline: "Business Exploration · GCC",
    heroTitle1: "Your bridge to the", heroTitleEm: "Middle East",
    heroSubtitle: "Qafila manages company requests to and from the Middle East: company profile, partner and client search.",
    startNow: "Get started", haveAccount: "I already have an account",
    annualContract: "Annual contract", successFeeResult: "Success fee on results",
    badgeText: "Success fee on generated contacts, only on results.",
    howItWorks: "How it works", howTitle: "From company to market in four steps",
    stepLabel: "Step",
    steps: [
      { title: "Register your company", text: "Enter your full business details: address, website, contact person and phone." },
      { title: "Company Profile", text: "Automatically generate a professional profile ready for the GCC market." },
      { title: "Submit your requests", text: "Targeted search for a specific mandate or general partnership with timelines." },
      { title: "Exploration contract", text: "Exploration and introduction contract with success fee." },
    ],
    ctaOverline: "Qafila", ctaTitle: "One partner to explore the Gulf markets.",
    ctaText: "We activate our network to generate qualified contacts and opportunities. You only pay on results, with a transparent fee defined in the exploration contract.",
    ctaButton: "Register your company for free",
    footer: "Qafila — Middle East Business Exploration",
  },
  login: {
    welcome: "Welcome back", title: "Sign in to your account",
    submit: "Sign in", submitting: "Signing in…",
    noAccount: "Don't have an account?", registerLink: "Register your company",
    heroText: "Explore new markets with a trusted partner.",
    success: "Signed in", emailPh: "name@company.com",
  },
  register: {
    overline: "Company registration", title: "Create your account",
    subtitle: "Enter your business details to start exploring the Middle East.",
    account: "Account", name: "Full name",
    company: "Business details", legalName: "Legal name", industry: "Industry",
    address: "Address", website: "Website",
    referent: "Contact person", refName: "Contact name", role: "Role", phone: "Phone",
    submit: "Register company", submitting: "Registering…",
    haveAccount: "Already have an account?", loginLink: "Sign in",
    heroText: "AI company profile, targeted requests and an annual exploration contract.",
    success: "Company registered successfully",
    ph: { name: "John Smith", email: "name@company.com", password: "min. 6 characters", legalName: "Company Ltd.", industry: "e.g. Manufacturing, Food, Tech", address: "Street, city, country", website: "https://…", refName: "Name", role: "e.g. CEO", phone: "+1…" },
  },
  nav: { overview: "Overview", profile: "Company Profile", requests: "Requests", contracts: "Contracts", logout: "Sign out" },
  overview: {
    welcome: "Welcome, {name}", title: "Your Qafila space",
    subtitle: "Manage your profile, requests and exploration contract for the Middle East.",
    statProfile: "Company Profile", complete: "Complete", toGenerate: "To generate",
    statRequests: "Requests sent", statContracts: "Contracts",
    aiTitle: "Generate your Company Profile with AI",
    aiText: "Turn your business data into a professional profile ready for the Gulf markets.",
    aiCta: "Go to Company Profile",
  },
  profile: {
    overline: "Company", title: "Company Profile",
    subtitle: "Update your details and generate the professional description with AI.",
    legalName: "Legal name", industry: "Industry", address: "Address", website: "Website",
    refName: "Contact name", role: "Role", phone: "Phone",
    notesLabel: "Notes for the AI (optional)", notesPh: "Main products/services, target markets, strengths…",
    descTitle: "Profile description", descSub: "Generated by AI from your business data.",
    generateAI: "Generate with AI", generating: "Generating…",
    descPh: "The generated description will appear here. You can also edit it manually.",
    save: "Save profile", saving: "Saving…",
    downloadPdf: "Download PDF", sendEmail: "Send by email", sending: "Sending…",
    saved: "Profile saved", generated: "Description generated with AI", sentTo: "Profile sent to {email}",
  },
  requests: {
    overline: "Search", title: "Your requests",
    subtitle: "Request a search for a specific mandate or a partnership.",
    newRequest: "New request", dialogTitle: "New request",
    typeLabel: "Request type", typeSpecific: "Specific mandate", typePartnership: "Partnership",
    titleLabel: "Title", descLabel: "Detailed description", descPh: "Describe the goal of the search…",
    timelineLabel: "Timeline", timelinePh: "e.g. within 3 months, Q3 2026…",
    submit: "Submit request", submitting: "Sending…",
    empty: "No requests yet. Create one to start the search.",
    typeSpecificFull: "Specific mandate", typePartnershipFull: "General partnership",
    adminNote: "Note from Qafila", timelinePrefix: "Timeline:", sent: "Request submitted",
    steps: ["Received", "In progress", "Completed", "Closed"],
    status: { nuova: "new", in_lavorazione: "in progress", completata: "completed", chiusa: "closed" },
  },
  contracts: {
    overline: "Agreements", title: "Exploration contracts",
    subtitle: "Annual contract with Qafila · 5% success fee on generated contacts.",
    generate: "Generate contract", dialogTitle: "Generate exploration contract",
    dialogText: "Link the contract to a specific request: the explored objective will appear clearly in the PDF.",
    objectiveLabel: "Contract objective", generalOption: "General search (Middle East)",
    optJob: "Mandate", optPartnership: "Partnership",
    confirm: "Generate contract", generating: "Generating…",
    empty: "No contracts. Generate one to formalize the search with Qafila.",
    linkedRequest: "Linked request:", company: "Company", successFee: "Success fee",
    start: "Start", end: "Expiry",
    downloadPdf: "Download PDF", sendEmail: "Send by email", sending: "Sending…",
    generated: "Exploration contract generated", sentTo: "Contract sent to {email}",
    sign: "Sign contract", signing: "Signing…", signedBadge: "Signed",
    signedOn: "Signed on {date}", signedToast: "Contract signed successfully",
  },
  admin: {
    badge: "Admin", panelOverline: "Control panel", title: "Administrator dashboard",
    logout: "Sign out",
    cardCompanies: "Companies", cardProfiles: "Company Profiles", cardRequests: "Requests", cardContracts: "Contracts",
    tabRequests: "Requests", tabCompanies: "Companies", tabContracts: "Contracts",
    noRequests: "No requests.", noCompanies: "No companies.", noContracts: "No contracts.",
    notesLabel: "Qafila internal notes (visible to the company)", notesPh: "Add feedback or updates for the company…",
    saveNote: "Save note", saving: "Saving…",
    sector: "Industry", site: "Website", referent: "Contact", tel: "Phone", fee: "Fee",
    timelinePrefix: "Timeline:", statusUpdated: "Status updated", noteSaved: "Note saved",
    typeSpecific: "Specific mandate", typePartnership: "Partnership",
  },
};

const fr = {
  common: {
    login: "Se connecter", register: "Inscrire l'entreprise", logout: "Déconnexion",
    orDivider: "ou", continueWithGoogle: "Continuer avec Google",
    loading: "Chargement…", email: "E-mail", password: "Mot de passe",
    activityLabel: "Activité (classification saoudienne)", activitySelect: "Sélectionner une activité", activityNone: "Aucune activité",
    durationYears: "Durée (années)", countersign: "Contresignature Qafila", countersigning: "Contresignature…",
    countersignedBadge: "Contresigné", countersignedOn: "Contresigné le {date}", countersignToast: "Contrat contresigné",
    notifications: "Notifications", noNotifications: "Aucune nouvelle demande", markAllRead: "Tout marquer comme lu",
    newRequestsCount: "{n} nouvelles demandes", byActivity: "Portfolio par activité",
    subActivityLabel: "Sous-activité (division)", subActivitySelect: "Sélectionner une sous-activité",
    filterActivity: "Filtrer par activité", allActivities: "Toutes les activités",
    exportExcel: "Exporter (Excel)", statistics: "Statistiques", statsCompanies: "Entreprises", statsRequests: "Demandes",
  },
  landing: {
    middleEast: "MIDDLE EAST BUSINESS PARTNER", login: "Se connecter", register: "Inscrire l'entreprise",
    heroOverline: "Business Exploration · CCG",
    heroTitle1: "Votre pont vers le", heroTitleEm: "Moyen-Orient",
    heroSubtitle: "Qafila gère les demandes des entreprises depuis et vers le Moyen-Orient : profil d'entreprise, recherche de partenaires et clients.",
    startNow: "Commencer", haveAccount: "J'ai déjà un compte",
    annualContract: "Contrat annuel", successFeeResult: "Commission au résultat",
    badgeText: "Commission de succès sur les contacts générés, uniquement au résultat.",
    howItWorks: "Comment ça marche", howTitle: "De l'entreprise au marché en quatre étapes",
    stepLabel: "Étape",
    steps: [
      { title: "Inscrivez votre entreprise", text: "Saisissez les données complètes : siège, site, personne de contact et téléphone." },
      { title: "Profil d'entreprise", text: "Générez automatiquement un profil professionnel prêt pour le marché du CCG." },
      { title: "Envoyez vos demandes", text: "Recherche ciblée pour une mission spécifique ou un partenariat général avec délais." },
      { title: "Contrat d'exploration", text: "Contrat d'exploration et d'introduction avec commission au succès." },
    ],
    ctaOverline: "Qafila", ctaTitle: "Un seul partenaire pour explorer les marchés du Golfe.",
    ctaText: "Nous activons notre réseau pour générer des contacts et opportunités qualifiés. Vous ne payez qu'au résultat, avec une commission transparente définie dans le contrat d'exploration.",
    ctaButton: "Inscrivez votre entreprise gratuitement",
    footer: "Qafila — Middle East Business Exploration",
  },
  login: {
    welcome: "Bon retour", title: "Connexion à votre compte",
    submit: "Se connecter", submitting: "Connexion…",
    noAccount: "Vous n'avez pas de compte ?", registerLink: "Inscrire votre entreprise",
    heroText: "Explorez de nouveaux marchés avec un partenaire de confiance.",
    success: "Connexion réussie", emailPh: "nom@entreprise.com",
  },
  register: {
    overline: "Inscription entreprise", title: "Créez votre compte",
    subtitle: "Saisissez les données de l'entreprise pour commencer à explorer le Moyen-Orient.",
    account: "Compte", name: "Nom et prénom",
    company: "Données de l'entreprise", legalName: "Raison sociale", industry: "Secteur",
    address: "Adresse", website: "Site internet",
    referent: "Personne de contact", refName: "Nom du contact", role: "Fonction", phone: "Téléphone",
    submit: "Inscrire l'entreprise", submitting: "Inscription…",
    haveAccount: "Vous avez déjà un compte ?", loginLink: "Se connecter",
    heroText: "Profil d'entreprise avec IA, demandes ciblées et contrat d'exploration annuel.",
    success: "Entreprise inscrite avec succès",
    ph: { name: "Jean Dupont", email: "nom@entreprise.com", password: "min. 6 caractères", legalName: "Entreprise SARL", industry: "ex. Industrie, Alimentaire, Tech", address: "Rue, ville, pays", website: "https://…", refName: "Nom", role: "ex. PDG", phone: "+33…" },
  },
  nav: { overview: "Aperçu", profile: "Profil d'entreprise", requests: "Demandes", contracts: "Contrats", logout: "Déconnexion" },
  overview: {
    welcome: "Bienvenue, {name}", title: "Votre espace Qafila",
    subtitle: "Gérez votre profil, vos demandes et le contrat d'exploration vers le Moyen-Orient.",
    statProfile: "Profil d'entreprise", complete: "Complet", toGenerate: "À générer",
    statRequests: "Demandes envoyées", statContracts: "Contrats",
    aiTitle: "Générez votre profil d'entreprise avec l'IA",
    aiText: "Transformez vos données en un profil professionnel prêt pour les marchés du Golfe.",
    aiCta: "Aller au profil d'entreprise",
  },
  profile: {
    overline: "Entreprise", title: "Profil d'entreprise",
    subtitle: "Mettez à jour les données et générez la description professionnelle avec l'IA.",
    legalName: "Raison sociale", industry: "Secteur", address: "Adresse", website: "Site internet",
    refName: "Nom du contact", role: "Fonction", phone: "Téléphone",
    notesLabel: "Notes pour l'IA (facultatif)", notesPh: "Produits/services principaux, marchés cibles, points forts…",
    descTitle: "Description du profil", descSub: "Générée par l'IA à partir de vos données.",
    generateAI: "Générer avec l'IA", generating: "Génération…",
    descPh: "La description générée apparaîtra ici. Vous pouvez aussi la modifier manuellement.",
    save: "Enregistrer le profil", saving: "Enregistrement…",
    downloadPdf: "Télécharger le PDF", sendEmail: "Envoyer par e-mail", sending: "Envoi…",
    saved: "Profil enregistré", generated: "Description générée avec l'IA", sentTo: "Profil envoyé à {email}",
  },
  requests: {
    overline: "Recherche", title: "Vos demandes",
    subtitle: "Demandez une recherche pour une mission spécifique ou un partenariat.",
    newRequest: "Nouvelle demande", dialogTitle: "Nouvelle demande",
    typeLabel: "Type de demande", typeSpecific: "Mission spécifique", typePartnership: "Partenariat",
    titleLabel: "Titre", descLabel: "Description détaillée", descPh: "Décrivez l'objectif de la recherche…",
    timelineLabel: "Délais", timelinePh: "ex. sous 3 mois, T3 2026…",
    submit: "Envoyer la demande", submitting: "Envoi…",
    empty: "Aucune demande pour l'instant. Créez-en une pour lancer la recherche.",
    typeSpecificFull: "Mission spécifique", typePartnershipFull: "Partenariat général",
    adminNote: "Note de Qafila", timelinePrefix: "Délais :", sent: "Demande envoyée",
    steps: ["Reçue", "En cours", "Terminée", "Clôturée"],
    status: { nuova: "nouvelle", in_lavorazione: "en cours", completata: "terminée", chiusa: "clôturée" },
  },
  contracts: {
    overline: "Accords", title: "Contrats d'exploration",
    subtitle: "Contrat annuel avec Qafila · commission de succès de 5% sur les contacts générés.",
    generate: "Générer le contrat", dialogTitle: "Générer un contrat d'exploration",
    dialogText: "Liez le contrat à une demande spécifique : l'objectif exploré apparaîtra clairement dans le PDF.",
    objectiveLabel: "Objectif du contrat", generalOption: "Recherche générale (Moyen-Orient)",
    optJob: "Mission", optPartnership: "Partenariat",
    confirm: "Générer le contrat", generating: "Génération…",
    empty: "Aucun contrat. Générez-en un pour formaliser la recherche avec Qafila.",
    linkedRequest: "Demande liée :", company: "Entreprise", successFee: "Commission",
    start: "Début", end: "Échéance",
    downloadPdf: "Télécharger le PDF", sendEmail: "Envoyer par e-mail", sending: "Envoi…",
    generated: "Contrat d'exploration généré", sentTo: "Contrat envoyé à {email}",
    sign: "Signer le contrat", signing: "Signature…", signedBadge: "Signé",
    signedOn: "Signé le {date}", signedToast: "Contrat signé avec succès",
  },
  admin: {
    badge: "Admin", panelOverline: "Panneau de contrôle", title: "Tableau de bord administrateur",
    logout: "Déconnexion",
    cardCompanies: "Entreprises", cardProfiles: "Profils", cardRequests: "Demandes", cardContracts: "Contrats",
    tabRequests: "Demandes", tabCompanies: "Entreprises", tabContracts: "Contrats",
    noRequests: "Aucune demande.", noCompanies: "Aucune entreprise.", noContracts: "Aucun contrat.",
    notesLabel: "Notes internes Qafila (visibles par l'entreprise)", notesPh: "Ajoutez un retour ou des mises à jour pour l'entreprise…",
    saveNote: "Enregistrer la note", saving: "Enregistrement…",
    sector: "Secteur", site: "Site", referent: "Contact", tel: "Tél", fee: "Commission",
    timelinePrefix: "Délais :", statusUpdated: "Statut mis à jour", noteSaved: "Note enregistrée",
    typeSpecific: "Mission spécifique", typePartnership: "Partenariat",
  },
};

const ar = {
  common: {
    login: "تسجيل الدخول", register: "تسجيل الشركة", logout: "تسجيل الخروج",
    orDivider: "أو", continueWithGoogle: "المتابعة عبر Google",
    loading: "جارٍ التحميل…", email: "البريد الإلكتروني", password: "كلمة المرور",
    activityLabel: "النشاط (التصنيف السعودي)", activitySelect: "اختر نشاطاً", activityNone: "بدون نشاط",
    durationYears: "المدة (سنوات)", countersign: "توقيع قافلة المضاد", countersigning: "جارٍ التوقيع…",
    countersignedBadge: "موقّع من الطرفين", countersignedOn: "تم التوقيع المضاد في {date}", countersignToast: "تم التوقيع المضاد على العقد",
    notifications: "الإشعارات", noNotifications: "لا توجد طلبات جديدة", markAllRead: "وضع الكل كمقروء",
    newRequestsCount: "{n} طلبات جديدة", byActivity: "المحفظة حسب النشاط",
    subActivityLabel: "النشاط الفرعي (التقسيم)", subActivitySelect: "اختر نشاطاً فرعياً",
    filterActivity: "تصفية حسب النشاط", allActivities: "كل الأنشطة",
    exportExcel: "تصدير (Excel)", statistics: "إحصائيات", statsCompanies: "الشركات", statsRequests: "الطلبات",
  },
  landing: {
    middleEast: "MIDDLE EAST BUSINESS PARTNER", login: "تسجيل الدخول", register: "تسجيل الشركة",
    heroOverline: "استكشاف الأعمال · دول الخليج",
    heroTitle1: "جسرك نحو", heroTitleEm: "الشرق الأوسط",
    heroSubtitle: "تدير قافلة طلبات الشركات من وإلى الشرق الأوسط: الملف التعريفي للشركة، والبحث عن الشركاء والعملاء.",
    startNow: "ابدأ الآن", haveAccount: "لديّ حساب بالفعل",
    annualContract: "عقد سنوي", successFeeResult: "عمولة عند النجاح",
    badgeText: "عمولة نجاح على جهات الاتصال المُولَّدة، عند تحقيق النتائج فقط.",
    howItWorks: "كيف تعمل", howTitle: "من الشركة إلى السوق في أربع خطوات",
    stepLabel: "خطوة",
    steps: [
      { title: "سجّل شركتك", text: "أدخل بيانات الشركة كاملة: المقر، الموقع، الشخص المسؤول والهاتف." },
      { title: "الملف التعريفي للشركة", text: "أنشئ تلقائياً ملفاً احترافياً جاهزاً لسوق دول الخليج." },
      { title: "أرسل طلباتك", text: "بحث موجَّه لمهمة محددة أو شراكة عامة مع جدول زمني." },
      { title: "عقد الاستكشاف", text: "عقد استكشاف وتقديم مع عمولة عند النجاح." },
    ],
    ctaOverline: "قافلة", ctaTitle: "شريك واحد لاستكشاف أسواق الخليج.",
    ctaText: "نُفعّل شبكتنا لتوليد جهات اتصال وفرص مؤهلة. تدفع عند تحقيق النتائج فقط، بعمولة شفافة محددة في عقد الاستكشاف.",
    ctaButton: "سجّل شركتك مجاناً",
    footer: "قافلة — استكشاف أعمال الشرق الأوسط",
  },
  login: {
    welcome: "مرحباً بعودتك", title: "تسجيل الدخول إلى حسابك",
    submit: "تسجيل الدخول", submitting: "جارٍ الدخول…",
    noAccount: "ليس لديك حساب؟", registerLink: "سجّل شركتك",
    heroText: "استكشف أسواقاً جديدة مع شريك موثوق.",
    success: "تم تسجيل الدخول", emailPh: "name@company.com",
  },
  register: {
    overline: "تسجيل الشركة", title: "أنشئ حسابك",
    subtitle: "أدخل بيانات الشركة لبدء استكشاف الشرق الأوسط.",
    account: "الحساب", name: "الاسم الكامل",
    company: "بيانات الشركة", legalName: "الاسم القانوني", industry: "القطاع",
    address: "العنوان", website: "الموقع الإلكتروني",
    referent: "الشخص المسؤول", refName: "اسم المسؤول", role: "المنصب", phone: "الهاتف",
    submit: "تسجيل الشركة", submitting: "جارٍ التسجيل…",
    haveAccount: "لديك حساب بالفعل؟", loginLink: "تسجيل الدخول",
    heroText: "ملف تعريفي بالذكاء الاصطناعي، طلبات موجَّهة، وعقد استكشاف سنوي.",
    success: "تم تسجيل الشركة بنجاح",
    ph: { name: "محمد أحمد", email: "name@company.com", password: "6 أحرف على الأقل", legalName: "شركة ذ.م.م", industry: "مثال: تصنيع، أغذية، تقنية", address: "الشارع، المدينة، الدولة", website: "https://…", refName: "الاسم", role: "مثال: الرئيس التنفيذي", phone: "+971…" },
  },
  nav: { overview: "نظرة عامة", profile: "ملف الشركة", requests: "الطلبات", contracts: "العقود", logout: "تسجيل الخروج" },
  overview: {
    welcome: "مرحباً، {name}", title: "مساحتك في قافلة",
    subtitle: "أدر ملفك وطلباتك وعقد الاستكشاف نحو الشرق الأوسط.",
    statProfile: "ملف الشركة", complete: "مكتمل", toGenerate: "بحاجة للإنشاء",
    statRequests: "الطلبات المُرسلة", statContracts: "العقود",
    aiTitle: "أنشئ ملف شركتك بالذكاء الاصطناعي",
    aiText: "حوّل بيانات شركتك إلى ملف احترافي جاهز لأسواق الخليج.",
    aiCta: "الذهاب إلى ملف الشركة",
  },
  profile: {
    overline: "الشركة", title: "ملف الشركة",
    subtitle: "حدّث البيانات وأنشئ الوصف الاحترافي بالذكاء الاصطناعي.",
    legalName: "الاسم القانوني", industry: "القطاع", address: "العنوان", website: "الموقع الإلكتروني",
    refName: "اسم المسؤول", role: "المنصب", phone: "الهاتف",
    notesLabel: "ملاحظات للذكاء الاصطناعي (اختياري)", notesPh: "المنتجات/الخدمات الرئيسية، الأسواق المستهدفة، نقاط القوة…",
    descTitle: "وصف الملف", descSub: "مُولَّد بالذكاء الاصطناعي من بيانات شركتك.",
    generateAI: "إنشاء بالذكاء الاصطناعي", generating: "جارٍ الإنشاء…",
    descPh: "سيظهر الوصف المُولَّد هنا. يمكنك أيضاً تعديله يدوياً.",
    save: "حفظ الملف", saving: "جارٍ الحفظ…",
    downloadPdf: "تنزيل PDF", sendEmail: "إرسال بالبريد", sending: "جارٍ الإرسال…",
    saved: "تم حفظ الملف", generated: "تم إنشاء الوصف بالذكاء الاصطناعي", sentTo: "تم إرسال الملف إلى {email}",
  },
  requests: {
    overline: "البحث", title: "طلباتك",
    subtitle: "اطلب بحثاً لمهمة محددة أو لشراكة.",
    newRequest: "طلب جديد", dialogTitle: "طلب جديد",
    typeLabel: "نوع الطلب", typeSpecific: "مهمة محددة", typePartnership: "شراكة",
    titleLabel: "العنوان", descLabel: "وصف مفصّل", descPh: "صف هدف البحث…",
    timelineLabel: "الجدول الزمني", timelinePh: "مثال: خلال 3 أشهر، الربع الثالث 2026…",
    submit: "إرسال الطلب", submitting: "جارٍ الإرسال…",
    empty: "لا توجد طلبات بعد. أنشئ طلباً لبدء البحث.",
    typeSpecificFull: "مهمة محددة", typePartnershipFull: "شراكة عامة",
    adminNote: "ملاحظة من قافلة", timelinePrefix: "الجدول الزمني:", sent: "تم إرسال الطلب",
    steps: ["مُستلَم", "قيد التنفيذ", "مكتمل", "مغلق"],
    status: { nuova: "جديد", in_lavorazione: "قيد التنفيذ", completata: "مكتمل", chiusa: "مغلق" },
  },
  contracts: {
    overline: "الاتفاقيات", title: "عقود الاستكشاف",
    subtitle: "عقد سنوي مع قافلة · عمولة نجاح 5% على جهات الاتصال المُولَّدة.",
    generate: "إنشاء عقد", dialogTitle: "إنشاء عقد استكشاف",
    dialogText: "اربط العقد بطلب محدد: سيظهر الهدف المُستكشَف بوضوح في ملف PDF.",
    objectiveLabel: "هدف العقد", generalOption: "بحث عام (الشرق الأوسط)",
    optJob: "مهمة", optPartnership: "شراكة",
    confirm: "إنشاء عقد", generating: "جارٍ الإنشاء…",
    empty: "لا توجد عقود. أنشئ عقداً لإضفاء الطابع الرسمي على البحث مع قافلة.",
    linkedRequest: "الطلب المرتبط:", company: "الشركة", successFee: "عمولة النجاح",
    start: "البداية", end: "الانتهاء",
    downloadPdf: "تنزيل PDF", sendEmail: "إرسال بالبريد", sending: "جارٍ الإرسال…",
    generated: "تم إنشاء عقد الاستكشاف", sentTo: "تم إرسال العقد إلى {email}",
    sign: "توقيع العقد", signing: "جارٍ التوقيع…", signedBadge: "موقّع",
    signedOn: "تم التوقيع في {date}", signedToast: "تم توقيع العقد بنجاح",
  },
  admin: {
    badge: "مشرف", panelOverline: "لوحة التحكم", title: "لوحة تحكم المشرف",
    logout: "تسجيل الخروج",
    cardCompanies: "الشركات", cardProfiles: "ملفات الشركات", cardRequests: "الطلبات", cardContracts: "العقود",
    tabRequests: "الطلبات", tabCompanies: "الشركات", tabContracts: "العقود",
    noRequests: "لا توجد طلبات.", noCompanies: "لا توجد شركات.", noContracts: "لا توجد عقود.",
    notesLabel: "ملاحظات قافلة الداخلية (مرئية للشركة)", notesPh: "أضف ملاحظات أو تحديثات للشركة…",
    saveNote: "حفظ الملاحظة", saving: "جارٍ الحفظ…",
    sector: "القطاع", site: "الموقع", referent: "المسؤول", tel: "هاتف", fee: "العمولة",
    timelinePrefix: "الجدول الزمني:", statusUpdated: "تم تحديث الحالة", noteSaved: "تم حفظ الملاحظة",
    typeSpecific: "مهمة محددة", typePartnership: "شراكة",
  },
};

export const translations = { it, en, fr, ar };
